import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative bg-[#FFF8F0] pt-12 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-21">
      <div className="max-w-5xl mx-auto" data-id="element-22">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-23">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex-1 text-center md:text-left z-10" data-id="element-24">
            <span className="inline-block py-1 px-3 rounded-full bg-[#E8DED3] text-[#2C2C2C] text-sm font-medium mb-6 tracking-wide" data-id="element-25">
              PARA MUJERES 35+
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] leading-tight mb-6" data-id="element-26">
              Tu fuerza de voluntad no está rota.{' '}
              <span className="text-[#D4735E]" data-id="element-27">Tu sistema sí.</span>
            </h1>

            <p className="text-xl text-[#5A5A5A] mb-8 leading-relaxed" data-id="element-28">
              El plan 35+ para apagar antojos nocturnos sin prohibirte todo.
            </p>

            <Button icon onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-29">
              Descubrir el Sistema
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          rotate: 2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="flex-1 relative" data-id="element-30">
            <div className="absolute inset-0 bg-[#8B9D83] rounded-2xl transform rotate-3 translate-x-4 translate-y-4 opacity-20" data-id="element-31"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cr6AhcxLTqb9bMGkSQmDwe/heylloyd-image-1768861948422.png" alt="Mujer leyendo Menopausia Sin Caos en tablet" className="relative rounded-2xl shadow-xl w-full object-cover aspect-[4/5] md:aspect-square" data-id="element-32" />
          </motion.div>
        </div>
      </div>
    </section>;
}